import { cardItems } from '@/mocks/darkwebData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            深度解读
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            暗网事件深度调查与分析，不止于表面报道
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-colors duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs px-2.5 py-0.5 rounded font-medium">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed flex-1">
                  {item.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500 pt-3 border-t border-background-200/70">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {item.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.readTime}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}